import type { TSignupElement } from '@shared/dream-components';

import type { NodeContent } from '~/interfaces/page';
import type { Publication } from '~/interfaces/publication';

function getSignupNodeContent(
  webTheme: Publication['web_theme'],
  overrides: Partial<TSignupElement['attrs']> = {},
): NodeContent {
  return {
    type: 'signup',
    attrs: {
      id: 'static_signup_element',
      data: [],
      padding: 4,
      buttonBackgroundColor: webTheme.primary_color,
      buttonTextColor: webTheme.text_on_primary_color,
      backgroundColor: webTheme.background_color,
      borderStyle: webTheme.border_style,
      borderWidth: '2px',
      borderColor: webTheme.border_color,
      borderRadius: webTheme.border_radius,
      buttonBorderRadius: webTheme.border_radius,
      inputBackgroundColor: webTheme.background_color,
      inputPlaceholderColor: webTheme.border_color,
      inputTextColor: webTheme.text_on_background_color,
      ...overrides,
    },
    content: [
      {
        id: '',
        text: '',
      },
    ],
  } as TSignupElement;
}

export { getSignupNodeContent };
